import { Mail } from "lucide-react";
import { Layout } from "./LegalPage";
import { getLang } from "../i18n";

const copy = {
  it: {
    title: "Assistenza",
    updated: "Supporto Pionieri e simpatizzanti",
    intro1a: "Per ricevere assistenza, oppure se hai domande sul progetto USTP inviaci una email. Ti risponderemo entro ",
    hours: "24 ore",
    intro1b: ".",
    mailLabel: "Indirizzo e-mail:",
    team: "Il Team",
  },
  en: {
    title: "Support",
    updated: "Support for Pioneers and supporters",
    intro1a: "To get support, or if you have questions about the USTP project, send us an email. We will reply within ",
    hours: "24 hours",
    intro1b: ".",
    mailLabel: "Email address:",
    team: "The Team",
  },
};

export default function AssistenzaPage() {
  const t = copy[getLang()];
  return (
    <Layout title={t.title} updated={t.updated}>
      <p>
        {t.intro1a}
        <strong>{t.hours}</strong>
        {t.intro1b}
      </p>
      <p>
        {t.mailLabel}{" "}
        <a
          href="mailto:info@ustp.it"
          data-testid="assistenza-mail"
          className="inline-flex items-center gap-1.5 font-mono font-bold text-sky-700 underline underline-offset-4 decoration-2 decoration-sky-300 hover:text-sky-600 transition-colors"
        >
          <Mail size={16} />
          info@ustp.it
        </a>
      </p>
      <p className="border-t border-slate-100 pt-6 font-display font-bold text-slate-900">
        {t.team}
        <span className="block font-mono text-xs font-normal tracking-[0.18em] text-slate-500 mt-1">
          USTP (UNIVERSE SCORE TOKEN PROTOCOL)
        </span>
      </p>
    </Layout>
  );
}
